import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in PayClassifications Manage loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in PayClassifications Manage loader'
  )

  return defer({
    data: Promise.all([])
      .then(() => true)
      .catch((error) => {
        logger.error('Pay Classifications Manage Promise.all error', error)
        return false
      }),
  })
}
